<template>
  <div class="nonum_box">
    <div class="nonum_left">
      <div class="two_mod" style="margin-bottom:0.15rem;">
        <div class="p_text">
          <p>您是希望整体预算优先，让定制师按照 <span>整体预算优先</span></p>
          <p>为您推荐符合您预算的产品呢？还是您需要整体 <span>产品标准优先</span>，</p>
          <p>让定制师以您的标准和预算帮您推荐商品？</p>
        </div>
        <div>
          <el-radio v-model="obj.desire" :label="1">整体预算优先</el-radio>
          <el-radio v-model="obj.desire" @click="goToInquiry" :label="2">按照我的标准来</el-radio>
        </div>
      </div>
      <div class="one_mod" @click.stop="">
        <b>亲，保证为您完成任务。咱们的目的地是？</b>   
        <city-autocomplete :obj="obj" :sizeType="'small'" :action="false" @handleSelect="handleSelect"></city-autocomplete>
      </div>
      <div class="two_mod" v-show="destination.length>0">
        <div class="p_tag cleanFloat">
          <span>亲，您选的是：</span>
          <p>
            <el-tag v-for="(tag,ind) in destination" :key="tag.id" closable @close="handleClose(destination,ind)"  size="small">{{tag.cityName}}</el-tag>
          </p>
        </div>
        <div class="p_text">
          <p> 好的，你的目的地收到！</p>
        </div>
      </div>
      <div class="three_mod" v-show="obj.desire ===1">
        <p>
          <b>预估出行人数：</b>
          <el-input-number v-model="obj.inquiryMaintainList[0].estimatedTravelAdultNum" :min="0" :max="99999" label="成人数" size="small"></el-input-number><span>成人</span>
          <el-input-number v-model="obj.inquiryMaintainList[0].estimatedTravelAdultChildren" :min="0" :max="99999" label="儿童数" size="small"></el-input-number><span>儿童</span>
        </p>
        <p>
          <b>预估出行日期：</b>
          <el-date-picker v-model="travelDate" value-format="yyyy-MM-dd" size="small" :unlink-panels="true" type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          <span>{{getBetweenDay(travelDate)}}天</span>
        </p>
        <p class="budgetClass">
          <b>预算：</b>
          <el-input v-model="obj.inquiryMaintainList[0].price" placeholder="单人预算" style="width:1rem;margin-right:0.05rem" size="small" 
            @input="obj.inquiryMaintainList[0].price=obj.inquiryMaintainList[0].price.replace(/[^\d]/g,'')"></el-input>
          <currency-autocomplete :obj="obj.inquiryMaintainList[0]" :sizeType="'small'"></currency-autocomplete>
          <span>
            <el-radio-group v-model="obj.inquiryMaintainList[0].type">
              <el-radio :label="0">不含机票</el-radio>
              <el-radio :label="1">含经济舱</el-radio>
              <el-radio :label="2">含公务/头等舱</el-radio>
            </el-radio-group>
          </span>
        </p>
        <p v-show="obj.inquiryMaintainList[0].type&&obj.inquiryMaintainList[0].type!==0">
          <b>出发地：</b>
          <city-autocomplete :obj="departurePlace" :sizeType="'small'"></city-autocomplete>
        </p>
        <p>
          亲 您这是私家团？还是企业出行？
          <span>
            <el-radio v-model="obj.type" :label="1" @change="changeType">私家团</el-radio>
            <el-radio v-model="obj.type" :label="2" @change="changeType">企业出行</el-radio>
          </span>
        </p>
      </div>
      <div class="private_mod label_mod" v-show="obj.type ===1">
        <div>
          <b>行程期待：</b>
          <p>
            <el-checkbox-group v-model="expectArr" size="mini">
              <el-checkbox-button v-for="lab in expectList" :label="lab" :key="lab">{{lab}}</el-checkbox-button>
            </el-checkbox-group>
          </p>
        </div>
        <div>
          <b>出游主题：</b>
          <p>
            <el-checkbox-group v-model="themeArr" size="mini">
              <el-checkbox-button v-for="lab in themeList" :label="lab" :key="lab">{{lab}}</el-checkbox-button>
            </el-checkbox-group>
          </p>
        </div>
      </div>
      <div class="enterprise_mod label_mod" v-show="obj.type ===2">
        <div>
          <b>所需服务：</b>
          <p>
            <el-checkbox-group v-model="serviceArr" size="mini">
              <el-checkbox-button v-for="lab in serviceList" :label="lab" :key="lab">{{lab}}</el-checkbox-button>
            </el-checkbox-group>
          </p>
        </div>
      </div>
      <div class="label_mod" v-show="obj.type">
        <div>
          <b>预算内包含的项目：</b>
          <p style="display: block;">
            <el-checkbox-group v-model="projectArrOne" size="mini">
              <el-checkbox-button v-for="lab in obj.type ===1?projectListOne:projectListTwo" :label="lab" :key="lab">{{lab}}</el-checkbox-button>
            </el-checkbox-group>
          </p>
        </div>
        <el-input v-model="obj.inquiryMaintainList[0].customerMessage" placeholder="您的别的要求"></el-input>
      </div>
    </div>
    <div class="nonum_right">
      <p class="nr_title">
        <i></i>
        <span>您的产品需求 </span>
      </p>
      <div class="demand_summary">
        <p v-show="destination.length>0">亲，这次准备前往的目的地是：
          <b v-for="(city,ind) in destination" :key="ind">{{city.cityName}}<span v-show="ind<destination.length-1">、</span></b>
        </p>
        <p v-show="destination.length>0">一个人的行走范围，就是他的世界。——北岛《青灯》。我们在世界里见证生命的丰富~</p>
        <p v-show="obj.desire">您想要<b>{{obj.desire===1?"整体预算优先":""}}</b>哦~~~木有问题！</p>
        <div v-show="obj.desire">
          <p>
            <span v-show="obj.inquiryMaintainList[0].estimatedTravelAdultNum>0||obj.inquiryMaintainList[0].estimatedTravelAdultChildren>0">
              亲，您这次的出行计划一共有
              <span v-show="obj.inquiryMaintainList[0].estimatedTravelAdultNum>0"><b>{{obj.inquiryMaintainList[0].estimatedTravelAdultNum}}</b>个成人</span>
              <span v-show="obj.inquiryMaintainList[0].estimatedTravelAdultChildren>0"><b>{{obj.inquiryMaintainList[0].estimatedTravelAdultChildren}}</b>个小朋友</span>
            </span>
            <span>
              <span v-show="travelDate!=''">&nbsp;预计<b>{{travelDate[0]}} 至 {{travelDate[1]}}</b>一共<b>{{getBetweenDay(travelDate)}}天</b></span>
              <span v-show="obj.inquiryMaintainList[0].price">每个人预算<b>{{obj.inquiryMaintainList[0].price}}{{obj.inquiryMaintainList[0].currency}}</b>以内</span>
              <span v-show="obj.inquiryMaintainList[0].type&&obj.inquiryMaintainList[0].type!=0||obj.type===0&&projectArrOne.length>0">
                <b>&nbsp;包含
                  <span v-show="obj.inquiryMaintainList[0].type==1||obj.inquiryMaintainList[0].type==2">
                    {{obj.inquiryMaintainList[0].type==1?'经济舱机票':'公务/头等舱机票'}}{{projectArrOne.length>0?'、':''}}
                  </span>
                  <span v-for="(lab,ind) in projectArrOne" :key="lab">{{lab}}<span v-show="ind<projectArrOne.length-1">、</span></span>
                </b>
              </span>
              <span v-show="departurePlace.cityName&&departurePlace.cityName!=''&&obj.inquiryMaintainList[0].type!==0"><b>，从{{departurePlace.cityName}}出发。</b></span>
            </span>
          </p>
          <div v-show="obj.type===1">
            <p>
              <span>咱们是<b>私人出行</b></span>
              <span v-show="expectArr.length>0||themeArr.length>0">,希望
                <b v-for="(lab,ind) in expectArr" :key="lab">{{lab}}<span v-show="ind<expectArr.length-1||themeArr.length>0">、</span></b>
                <b v-for="(lab,ind) in themeArr" :key="lab">{{lab}}<span v-show="ind<themeArr.length-1">、</span></b>
                ~~的旅程
              </span>
            </p>
          </div>
          <div v-show="obj.type===2">
            <p>
              <span>咱们是<b>企业出行</b></span>
              <span>，需要的服务涉及到<b v-for="(lab,ind) in serviceArr" :key="lab">{{lab}}<span v-show="ind<serviceArr.length-1">、</span></b>。</span>
            </p>
          </div>
          <div v-if="obj.type">
            <p v-show="obj.inquiryMaintainList[0].customerMessage!=''">
              您希望<b>{{obj.inquiryMaintainList[0].customerMessage}}</b>
            </p>
            <p>好嘞！ 上述信息全部收到!  您的这些需求，我们在为您推荐行程和产品的时候都会考虑到滴，保证让您满意！</p>
            <div class="btnBox">
              <button @click="sendInquiry">请尽快给我提供与我的预算匹配的产品方案</button>  
            </div>
          </div>
        </div>
      </div>
    </div>
    <send-inquiry-dialog :identity="'定制师'" ref="sendInquiry"></send-inquiry-dialog>
  </div>
</template>

<script>
import CityAutocomplete from '../common/cityAutocomplete.vue'
import CurrencyAutocomplete from '../common/currencyAutocomplete.vue'
import SendInquiryDialog from './sendInquiryDialog.vue'
export default {
  data(){
    return{
      obj:{
        desire:null,
        cityId:null,
        cityName:null,
        type:null,
        inquiryMaintainList:[{
          estimatedTravelAdultNum:0,
          estimatedTravelAdultChildren:0,
          price:null,
          currency:null,
          type:null,
          customerMessage:''
        }],
      },
      departurePlace:{
        cityId:null,
        cityName:null,
      },
      expectArr:[],
      expectList:["安排紧凑","行程宽松","地标打卡","大快朵颐"],
      themeArr:[],
      themeList:["带孩子","带爹娘","好盆友","撒狗粮","仪式感/蜜月","自己玩儿"],
      serviceArr:[],
      serviceList:["公司旅游","团建拓展","会议培训","商务考察","市场推广","国际会议","参展观展","媒体方案","服务人员","邀请函","国外秀场","VI等设计","摄影摄像"],
      projectArrOne:[],
      projectListOne:["火车/轮船","酒店","包车","景点","美食","导游","签证","当地特色体验","仪式感活动安排","摄影摄像"],
      projectListTwo:["火车/轮船","酒店","包车","景点","美食","导游","签证","当地特色体验","仪式感活动安排","摄影摄像","团建策划","会场租赁","会议服务","会议设备租赁","教授联系","联系拜访/座谈","品牌推广","产品发布","客户答谢","品牌露出材料制作","大会代为注册","大会代为报道","展场租赁","展场搭建","展会设备租赁","活动媒体邀约","媒体发布","活动礼仪","翻译","安保人员","活动保洁","主持人","演出人员","控场/导演","视频剪辑及后期人员","现场服务人员","政府邀请函","商务邀请函","秀票购买及接送","AI设计","活动用图"],
      travelDate:[],
      destination:[],
    }
  },
  components:{CityAutocomplete,CurrencyAutocomplete,SendInquiryDialog},
  methods:{
    handleSelect(item){
      this.destination.push({
        id:item.id,
        cityName:item.cityNameCn
      })
    },
    goToInquiry(){
      this.$router.push({ name: "productInquiry", });
    },
    handleClose(data,indec){
      data.splice(indec, 1)
    },
    changeType(){
      this.projectArrOne = []
    },
    sendInquiry(){
      this.obj.inquiryMaintainList[0].destination = JSON.stringify(this.destination)
      this.obj.inquiryMaintainList[0].estimatedTravelStart = this.travelDate[0]
      this.obj.inquiryMaintainList[0].estimatedTravelEnd = this.travelDate[1]
      this.obj.inquiryMaintainList[0].theme = this.obj.type==2?JSON.stringify(this.serviceArr):JSON.stringify(this.themeArr)
      this.obj.inquiryMaintainList[0].needService =JSON.stringify(this.projectArrOne)
      this.obj.inquiryMaintainList[0].planExpect = JSON.stringify(this.expectArr)
      this.obj.inquiryMaintainList[0].departurePlace = JSON.stringify(this.departurePlace)
      this.$refs.sendInquiry.sumitBoxState = true
      this.$refs.sendInquiry.saveObj = this.obj
    }
  }
}
</script>

<style>
.nonum_box .label_mod .el-checkbox-button--mini .el-checkbox-button__inner{
  margin:0.05rem;
  border-radius: 4px;
}
.nonum_box .two_mod .el-tag--small{
  margin:0.05rem;
}
.nonum_box .submitBox{
  top: 5.5rem;
  right: 3.7rem;
}
</style>
<style lang="scss" scoped>
.nonum_box{
  width:12rem;
  margin:0 auto 0.4rem auto;
  padding-top: 0.6rem;
  display: flex;
  color: #333;
  .nonum_left{
    width:50%;
  }
  .two_mod{
    .p_text{
      >p{
        margin-bottom: 0.13rem;
        font-weight: bold;
        letter-spacing: 0.01rem;
        >span{
          font-size:0.18rem;
        }
      }       
    }
    .p_tag{
      margin:0.1rem 0;
      padding-left:0.3rem;
      p{
        display: inline-block;
        width: 4.65rem;
      }
    }
  }
  .three_mod{
    >p{
      margin:0.15rem 0;
      >span{
        margin:0 7px;
      }
    }
  }
  .label_mod{
    >div{
      margin:0.15rem 0;
      b{
        display: inline-block;
        height:0.38rem;
        line-height: 0.38rem;
        vertical-align: top;
      }
      >p{
        display: inline-block;
        width: 5.25rem;
      }
    } 
  }
  .nonum_right{
    width:50%;
    .nr_title{
      position: relative;
      text-align: right;
      i{
        position: absolute;
        right: 0;
        bottom: 0;
        background: #FCEDE8;
        display: inline-block;
        height: 10px;
        width: 200px;
        z-index: -2;
      }
      span{
        font-weight: bold;
        font-size: 20px;
      }
    }
    .demand_summary{
      margin: 0.3rem 0 0 0.3rem;
      min-height: 4rem;
      background: #FEF9F9;
      border-radius: 30px;
      box-shadow: 0px 0px 30px 0px #bbb;
      padding: 0.4rem;
      p{
        margin:0.19rem 0;
        line-height: 0.2rem;
      }
      .btnBox{
        text-align: center;
        button{
          background: #E65019;
          font-size:0.18rem;
          height:0.36rem;
          border-radius: 36px;
          border: none;
          width:4.25rem;
          color:#fff;
        }
        
      }
    }
  }
}
</style>